import '.d{display:flex;}.ssr-plugin'
import '.a0{background-color:white;}.ssr-plugin'
import '.a1{border-radius:20px;}.ssr-plugin'
import '.a2{border:var(--border-subtle);}.ssr-plugin'
import '.a3{overflow:hidden;}.ssr-plugin'
import '.a4{padding:1rem;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.a5{align-items:flex-start;}.ssr-plugin'
import '.a6{background-color:var(--palette-blue-50);}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.a7{align-items:center;}.ssr-plugin'
import '.a8{justify-content:center;}.ssr-plugin'
import '.a9{width:6.1875rem;}.ssr-plugin'
import '.aa{border-radius:9px;}.ssr-plugin'
import '.ab{gap:0.5rem;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Text } from '@app/components/core/typography/Text'
import Column from '@app/components/layout/Column'

export interface EventProps {
  date: number
  month: string
  category: string
  title: string
  description?: string
  time: string
  location: string
  onClick?: () => void
  style?: Style
}

export const Event = ({
  date,
  month,
  category,
  title,
  description,
  time,
  location,
  onClick,
  style,
}: EventProps) => {
  return (
    <styled.div className="d a0 a1 a2 a3 a4 n a5"
      onClick={onClick}
      style={{
        cursor: onClick ? 'pointer' : 'default',
        ...style,
      }}
    >
      {/* Date Section */}
      <div className="a6 a4 d e a7 a8 a9 aa"
        data-testid="event-date-section"
      >
        <Text.Large
          style={{
            fontSize: '3.6rem',
            fontWeight: '700',
            color: 'var(--palette-blue-500)',
            lineHeight: '1',
            margin: 0,
          }}
          color="var(--palette-blue-500)"
        >
          {date}
        </Text.Large>
        <Text.ExtraSmall color="var(--palette-blue-500)">
          {String(month).toUpperCase()}
        </Text.ExtraSmall>
      </div>

      {/* Event Details Section */}
      <Column
        style={{
          height: '100%',
          padding: '0 1rem',
          flex: 1,
          alignItems: 'flex-start',
          justifyContent: 'space-between',
        }}
        gap="0.5rem"
      >
        <div className="ab">
          {/* Category */}
          <Text.ExtraSmall
            isBold={true}
            style={{ marginBottom: '0.5rem' }}
            color="var(--brand-primary)"
          >
            {category.toUpperCase()}
          </Text.ExtraSmall>

          {/* Title */}
          <Text.Medium
            style={{
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              marginBottom: '0.5rem',
            }}
            color="var(--brand-secondary)"
          >
            {title}
          </Text.Medium>

          {/* Description */}
          {description && (
            <Text.Small
              style={{
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
              }}
              color="var(--palette-blue-600)"
            >
              {description}
            </Text.Small>
          )}
        </div>
        {/* Time and Location - aligned to bottom */}
        <styled.div>
          <Text.ExtraSmall
            style={{
              WebkitLineClamp: 1,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
            }}
            color="var(--brand-secondary)"
          >
            {time} · {location}
          </Text.ExtraSmall>
        </styled.div>
      </Column>
    </styled.div>
  )
}
